var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3fea73112f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.253906 13.253906 L 365.003906 13.253906 L 365.003906 365.003906 L 13.253906 365.003906 Z M 13.253906 13.253906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3fea73112f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M 189.042969 13.253906 C 91.871094 13.253906 13.253906 91.957031 13.253906 189.128906 C 13.253906 286.300781 91.871094 365.003906 189.042969 365.003906 C 286.210938 365.003906 365.003906 286.300781 365.003906 189.128906 C 365.003906 91.957031 286.210938 13.253906 189.042969 13.253906 Z M 189.128906 329.828125 C 111.394531 329.828125 48.429688 266.867188 48.429688 189.128906 C 48.429688 111.394531 111.394531 48.429688 189.128906 48.429688 C 266.867188 48.429688 329.828125 111.394531 329.828125 189.128906 C 329.828125 266.867188 266.867188 329.828125 189.128906 329.828125 Z M 189.128906 329.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    d: "M 197.921875 101.191406 L 171.542969 101.191406 L 171.542969 206.71875 L 263.789062 262.117188 L 277.066406 240.484375 L 197.921875 193.527344 Z M 197.921875 101.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.12579523c2c7176ffa1e76fd609ef97d.svg";
export { ForwardRef as ReactComponent };